/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
// import { Dropdown } from "../reuseable";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/
import {
  polygon_units,
  line_units,
} from "../../App/validation/geometry_to_area_or_length";

/*DATA*/
// import dict from "../../Data/dict.json";

/*CONST*/

const SET_CD = ({
  //variable
  // auth,
  layer,
  properties,

  //function
  set_value_properties,
}) => {
  //localStorage

  //state & ref

  //global props
  const { field_editable } = properties;
  const { unit } = field_editable || {};
  const { geo_layer_list, layer_id } = layer;

  //variables
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id
  )?.geo_layer;
  const { type } = geo_layer || {};

  //functions
  const handleChange = (e) => {
    e.preventDefault();
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let field = { ...field_editable };
    if (["tag"].includes(name)) {
      const tagArray = value.split("\n");
      const array_templates = tagArray.map((value, idx) => {
        return { name: value, index: idx };
      });
      const is_any_equal_to_value = array_templates.some(
        ({ name }) => name === field?.value
      );
      field[name] = value;
      field.array_templates = array_templates;
      field.defaultValue = "";
      if (!is_any_equal_to_value) field.value = "";
    } else {
      field[name] = value;
    }
    set_value_properties({
      key: "field_editable",
      value: field,
    });
  };


  return (
    <main>
      <h1 className="text_bold margin_bottom">
        Pengaturan Calculated Dimension
      </h1>

      <div
        className="container background_grey_light outline_grey"
        style={{ marginBottom: "15px" }}
      >
        <div className="text_bold">{"Unit"}</div>
        <select
          id="unit"
          name="unit"
          value={unit}
          onChange={handleChange}
        >
          <option value="">Select</option>
          {(type === "MultiLineString" || type === "LineString") &&
            line_units.map((element, index) => (
              <option key={index} value={element.key}>
                {element.name}
              </option>
            ))}
          {(type === "Polygon" || type === "MultiPolygon") &&
            polygon_units.map((element, index) => (
              <option key={index} value={element.key}>
                {element.name}
              </option>
            ))}
        </select>
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties })(SET_CD);
